const exchanges = [
    {
        country: 'ar',
        data: [
            {
                key: 'operation',
                texts: [
                    {
                        singular: 'venta',
                        plural: 'Ventas'
                    },
                    {
                        singular: 'alquiler',
                        plural: 'Alquileres'
                    },
                    {
                        singular: 'alquiler temporario',
                        plural: 'Alquileres temporarios'
                    },
                    {
                        singular: 'permuta',
                        plural: 'Permutas'
                    }
                    // {
                    //     singular: 'compartir',
                    //     plural: 'Compartidos'
                    // }
                ]
            },
            {
                key: 'type',
                texts: [
                    {
                        singular: 'departamento',
                        plural: 'departamentos'
                    },
                    {
                        singular: 'casa',
                        plural: 'casas'
                    },
                    {
                        singular: 'quinta',
                        plural: 'quintas'
                    },
                    {
                        singular: 'terreno',
                        plural: 'terrenos'
                    },
                    {
                        singular: 'campo',
                        plural: 'campos'
                    },
                    {
                        singular: 'cochera',
                        plural: 'cocheras'
                    },
                    {
                        singular: 'oficina',
                        plural: 'oficinas'
                    },
                    {
                        singular: 'galpon',
                        plural: 'galpones'
                    },
                    {
                        singular: 'local comercial',
                        plural: 'locales comerciales'
                    },
                    {
                        singular: 'ph',
                        plural: 'ph'
                    },
                    {
                        singular: 'duplex',
                        plural: 'duplex'
                    },
                    {
                        singular: 'fondo comercio',
                        plural: 'fondo comercio'
                    },
                    {
                        singular: 'isla',
                        plural: 'islas'
                    },
                    {
                        singular: 'hotel',
                        plural: 'hoteles'
                    },
                    {
                        singular: 'garage',
                        plural: 'garages'
                    },
                    {
                        singular: 'chacra',
                        plural: 'chacras'
                    },
                    {
                        singular: 'complejo turistico',
                        plural: 'complejos turisticos'
                    },
                    {
                        singular: 'triplex',
                        plural: 'triplex'
                    },
                    {
                        singular: 'edificio',
                        plural: 'edificios'
                    },
                    {
                        singular: 'loft',
                        plural: 'loft'
                    },
                    {
                        singular: 'cabana',
                        plural: 'cabañas'
                    },
                    {
                        singular: 'otro inmueble',
                        plural: 'otros inmuebles'
                    }
                ]
            }
        ]
    },
    {
        country: 'es',
        data: [
            {
                key: 'operation',
                texts: [
                    {
                        singular: 'venta',
                        plural: 'Ventas'
                    },
                    {
                        singular: 'alquiler',
                        plural: 'Alquileres'
                    },
                    {
                        singular: 'alquiler vacacional',
                        plural: 'Alquileres vacacionales'
                    },
                    {
                        singular: 'permuta',
                        plural: 'Permutas'
                    },
                    {
                        singular: 'transferir',
                        plural: 'Transferencias'
                    },
                    {
                        singular: 'compartir',
                        plural: 'Compartidos'
                    }
                ]
            },
            {
                key: 'type',
                texts: [
                    {
                        singular: 'piso',
                        plural: 'pisos'
                    },
                    {
                        singular: 'casa',
                        plural: 'casas'
                    },
                    {
                        singular: 'casa rural',
                        plural: 'casas rurales'
                    },
                    {
                        singular: 'terreno',
                        plural: 'terrenos'
                    },
                    {
                        singular: 'finca',
                        plural: 'fincas'
                    },
                    {
                        singular: 'garaje',
                        plural: 'garajes'
                    },
                    {
                        singular: 'oficina',
                        plural: 'oficinas'
                    },
                    {
                        singular: 'nave industrial',
                        plural: 'naves industriales'
                    },
                    {
                        singular: 'local comercial',
                        plural: 'locales comerciales'
                    },
                    {
                        singular: 'ph',
                        plural: 'ph'
                    },
                    {
                        singular: 'duplex',
                        plural: 'duplex'
                    },
                    {
                        singular: 'negocio',
                        plural: 'negocios'
                    },
                    {
                        singular: 'isla',
                        plural: 'islas'
                    },
                    {
                        singular: 'hotel',
                        plural: 'hoteles'
                    },
                    {
                        singular: 'aparcamiento',
                        plural: 'aparcamientos'
                    },
                    {
                        singular: 'finca rustica',
                        plural: 'fincas rústicas'
                    },
                    {
                        singular: 'complejo turistico',
                        plural: 'complejos turisticos'
                    },
                    {
                        singular: 'triplex',
                        plural: 'triplex'
                    },
                    {
                        singular: 'edificio',
                        plural: 'edificios'
                    },
                    {
                        singular: 'loft',
                        plural: 'loft'
                    },
                    {
                        singular: 'cabana turistica',
                        plural: 'cabañas turisticas'
                    },
                    {
                        singular: 'otro inmueble',
                        plural: 'otros inmuebles'
                    }
                ]
            }
        ]
    },
    {
        country: 'uy',
        data: [
            {
                key: 'operation',
                texts: [
                    {
                        singular: 'venta',
                        plural: 'Ventas'
                    },
                    {
                        singular: 'alquiler',
                        plural: 'Alquileres'
                    },
                    {
                        singular: 'alquiler temporada',
                        plural: 'Alquileres temporada'
                    },
                    {
                        singular: 'permuta',
                        plural: 'Permutas'
                    },
                    {
                        singular: 'compartir',
                        plural: 'Compartidos'
                    }
                ]
            },
            {
                key: 'type',
                texts: [
                    {
                        singular: 'apartamento',
                        plural: 'apartamentos'
                    },
                    {
                        singular: 'casa',
                        plural: 'casas'
                    },
                    {
                        singular: 'quinta',
                        plural: 'quintas'
                    },
                    {
                        singular: 'terreno',
                        plural: 'terrenos'
                    },
                    {
                        singular: 'campo',
                        plural: 'campos'
                    },
                    {
                        singular: 'garaje',
                        plural: 'garajes'
                    },
                    {
                        singular: 'oficina',
                        plural: 'oficinas'
                    },
                    {
                        singular: 'galpon',
                        plural: 'galpones'
                    },
                    {
                        singular: 'local comercial',
                        plural: 'locales comerciales'
                    },
                    {
                        singular: 'ph',
                        plural: 'ph'
                    },
                    {
                        singular: 'duplex',
                        plural: 'duplex'
                    },
                    {
                        singular: 'negocio',
                        plural: 'negocios'
                    },
                    {
                        singular: 'isla',
                        plural: 'islas'
                    },
                    {
                        singular: 'hotel',
                        plural: 'hoteles'
                    },
                    {
                        singular: 'parking',
                        plural: 'parking'
                    },
                    {
                        singular: 'chacra',
                        plural: 'chacras'
                    },
                    {
                        singular: 'complejo turistico',
                        plural: 'complejos turisticos'
                    },
                    {
                        singular: 'triplex',
                        plural: 'triplex'
                    },
                    {
                        singular: 'edificio',
                        plural: 'edificios'
                    },
                    {
                        singular: 'loft',
                        plural: 'loft'
                    },
                    {
                        singular: 'cabana',
                        plural: 'cabañas'
                    },
                    {
                        singular: 'otro inmueble',
                        plural: 'otros inmuebles'
                    }
                ]
            }
        ]
    },
    {
        country: 'cl',
        data: [
            {
                key: 'operation',
                texts: [
                    {
                        singular: 'venta',
                        plural: 'Ventas'
                    },
                    {
                        singular: 'arriendo',
                        plural: 'Arriendos'
                    },
                    {
                        singular: 'arriendo temporal',
                        plural: 'Arriendos temporales'
                    },
                    {
                        singular: 'permuta',
                        plural: 'Permutas'
                    },
                    {
                        singular: 'compartir',
                        plural: 'Compartidos'
                    }
                ]
            },
            {
                key: 'type',
                texts: [
                    {
                        singular: 'departamento',
                        plural: 'departamentos'
                    },
                    {
                        singular: 'casa',
                        plural: 'casas'
                    },
                    {
                        singular: 'sitio',
                        plural: 'sitios'
                    },
                    {
                        singular: 'terreno',
                        plural: 'terrenos'
                    },
                    {
                        singular: 'agricolas',
                        plural: 'agrícolas'
                    },
                    {
                        singular: 'aparcamiento',
                        plural: 'aparcamientos'
                    },
                    {
                        singular: 'oficina',
                        plural: 'oficinas'
                    },
                    {
                        singular: 'industrial',
                        plural: 'industriales'
                    },
                    {
                        singular: 'local comercial',
                        plural: 'locales comerciales'
                    },
                    {
                        singular: 'condominio',
                        plural: 'condominios'
                    },
                    {
                        singular: 'duplex',
                        plural: 'duplex'
                    },
                    {
                        singular: 'negocio',
                        plural: 'negocios'
                    },
                    {
                        singular: 'isla',
                        plural: 'islas'
                    },
                    {
                        singular: 'hotel',
                        plural: 'hoteles'
                    },
                    {
                        singular: 'parking',
                        plural: 'parking'
                    },
                    {
                        singular: 'parcela',
                        plural: 'parcelas'
                    },
                    {
                        singular: 'complejo turistico',
                        plural: 'complejos turisticos'
                    },
                    {
                        singular: 'triplex',
                        plural: 'triplex'
                    },
                    {
                        singular: 'edificio',
                        plural: 'edificios'
                    },
                    {
                        singular: 'loft',
                        plural: 'loft'
                    },
                    {
                        singular: 'cabana turistica',
                        plural: 'cabañas turisticas'
                    },
                    {
                        singular: 'otro inmueble',
                        plural: 'otros inmuebles'
                    }
                ]
            }
        ]
    }
]

export default exchanges
